"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import t from "../components/Icon/SvgIcon.js";
const r = (l) => /* @__PURE__ */ o(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M19.362 12.447 5.05 20.77a.34.34 0 0 1-.481-.07.35.35 0 0 1-.069-.207V3.847c0-.192.154-.347.344-.347.075 0 .147.024.206.07l14.312 8.322a.348.348 0 0 1 0 .555",
        clipRule: "evenodd"
      }
    )
  }
), a = e(r);
export {
  a as Play,
  a as default
};
